// extracted by mini-css-extract-plugin
export default {"emptyStateBox":"styles_emptyStateBox__XLtXr","noDownloadLinkFoundIcon":"styles_noDownloadLinkFoundIcon__ggNOB"};